import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_register = _resolveComponent("register")!
  const _component_login = _resolveComponent("login")!
  const _component_reset_pw_reset_token = _resolveComponent("reset-pw-reset-token")!
  const _component_reset_pw = _resolveComponent("reset-pw")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('app_name')), 1),
    (_ctx.view === 'register')
      ? (_openBlock(), _createBlock(_component_register, {
          key: 0,
          onLogin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.view = 'login'))
        }))
      : (_ctx.view === 'login')
        ? (_openBlock(), _createBlock(_component_login, {
            key: 1,
            onResetPw: _cache[1] || (_cache[1] = ($event: any) => (_ctx.view = 'reset')),
            onRegister: _cache[2] || (_cache[2] = ($event: any) => (_ctx.view = 'register'))
          }))
        : (_ctx.view === 'resetPwResetToken')
          ? (_openBlock(), _createBlock(_component_reset_pw_reset_token, {
              key: 2,
              onLogin: _cache[3] || (_cache[3] = ($event: any) => (_ctx.view = 'login'))
            }))
          : (_openBlock(), _createBlock(_component_reset_pw, {
              key: 3,
              onLogin: _cache[4] || (_cache[4] = ($event: any) => (_ctx.view = 'login')),
              onResetPwResetToken: _cache[5] || (_cache[5] = ($event: any) => (_ctx.view = 'resetPwResetToken'))
            }))
  ]))
}